var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",function(){return [_c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))]},{"attrs":_vm.$attrs,"listeners":_vm.$listeners})],2)}
var staticRenderFns = []

export { render, staticRenderFns }